import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { SparklesIcon, PaletteIcon, WavesIcon, SunIcon, ClockIcon } from 'lucide-react';
const benefits = [{
  icon: SparklesIcon,
  text: 'The laser stimulates collagen production, leading to smoother and more refined skin texture.'
}, {
  icon: PaletteIcon,
  text: 'By targeting areas of uneven pigmentation, the treatment helps to create a more uniform complexion.'
}, {
  icon: WavesIcon,
  text: 'The collagen-stimulating effects of the laser can diminish the appearance of fine lines and wrinkles over time.'
}, {
  icon: SunIcon,
  text: 'Patients often notice a brighter and more radiant complexion following the treatment.'
}, {
  icon: ClockIcon,
  text: 'Since the ClearSilk Facial is gentle on the skin, there is typically no downtime required.'
}];
export function CSTreatment() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-628">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-629">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-630">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-631">
            Be YOU
          </span>

          <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-632">
            WHAT HAPPENS DURING A CLEARSILK TREATMENT?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-633"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.7] font-body max-w-[800px]" data-id="element-634">
            <p data-id="element-635">
              During the treatment, the laser delivers controlled pulses of
              light energy to the skin, stimulating collagen production and
              promoting cellular turnover. This process helps to reduce the
              appearance of imperfections, leaving the skin smoother, firmer,
              and more youthful-looking.
            </p>
            <p data-id="element-636">
              The ClearSilk Laser Facial is non-invasive and requires no
              downtime, making it a convenient option for busy individuals
              seeking to refresh their complexion. Patients may experience a
              mild warming sensation during the treatment, but discomfort is
              minimal and well-tolerated.
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5" data-id="element-637">
          {benefits.map((benefit, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-638">
              <div className="bg-[#111111] p-7 text-center h-full group hover:shadow-[0_0_20px_rgba(255,20,147,0.1)] transition-shadow duration-300" data-id="element-639">
                <benefit.icon size={36} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-640" />
                <p className="text-white text-sm leading-[1.6] font-body" data-id="element-641">
                  {benefit.text}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}